// extracted by mini-css-extract-plugin
module.exports = {"menuPaper":"AmbassadorMenu_menuPaper__3bQ71","menuList":"AmbassadorMenu_menuList__1pzpu","menuItem":"AmbassadorMenu_menuItem__2uQNN"};